module.exports = __webpack_public_path__ + "static/img/fh_icon.png";